import { interval as observableInterval, timer as observableTimer } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';
import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { IrisProtocolService } from '../../../../../common/services/protocol-service.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SkModalBase } from '@ngx-strakit/cdk';

type ExtendedUserI = IdentUserI & { companyName: string };

@Component({
  selector: 'iris-notifications-unlock-modal',
  styleUrls: ['./notifications-unlock-modal.component.scss'],
  templateUrl: './notifications-unlock-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IrisNotificationsUnlockModalComponent extends SkModalBase<IrisNotificationsUnlockModalComponent, void> implements OnInit, OnDestroy {
  private readonly protocolService = inject(IrisProtocolService);
  private readonly data = inject<{
    user: ExtendedUserI;
    protocolId: number;
  }>(MAT_DIALOG_DATA);

  readonly user = this.data.user ?? {} as ExtendedUserI;
  readonly protocolId = this.data.protocolId;
  countDown = 6 * 60;
  private countdownObservable$;

  ngOnInit(): void {
    const unlockAfterTimerObservable$ = observableTimer(6 * 60 * 1000).pipe(
      tap(() => this.unlock()));

    this.countdownObservable$ = observableInterval(1000).pipe(
      map(() => this.countDown--),
      takeUntil(unlockAfterTimerObservable$) ).subscribe();

  }

  ngOnDestroy(): void {
    super.ngOnDestroy();

    if (this.countdownObservable$) {
      this.countdownObservable$.unsubscribe();
    }
  }

  public unlock(): void {
    this.protocolService.unlock(this.protocolId, this.user.id).pipe(
      tap(() => this.dialogRef.close()),
    ).subscribe();
  }

  public reject(): void {
    this.protocolService.rejectUnlock(this.protocolId, this.user.id).pipe(
      tap(() => this.dialogRef.close()),
    ).subscribe();
  }

}
